export default __webpack_public_path__ + "static/media/Deposit.132b55bb.svg";